/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Button } from "@mui/material";
import SearchBox from "components/ui/searchBox";
import { viewAllPayment } from "features/payments/api/payments";
import useApiCall from "hooks/useApiCall";
import { useDebounce } from "hooks/useDebounce";
import { useEffect, useState } from "react";
import PaymentTable from "./PaymentTable";
import { BiPlus } from "react-icons/bi";
import MakePayment from "./MakePayment";
import useBase from "hooks/useBase";
import usePermissions from "hooks/usePermissions";

const Payment = ({
  customer_id,
  project_id,
  invoice_id,
  isCreate = false,
  isEdit = false,
  isDelete = false,
}) => {
  const { base } = useBase([
    "assignees",
    "customers",
    "intakes",
    "projects",
    "fees",
    "currencies",
    "settings",
    "references",
    "paymentMethods",
    "branches",
    "invoices",
    "banks",
  ]);

  const [addPayment, setAddPayment] = useState(false);
  const [currPayment, setCurrPayment] = useState({});
  const [allPayment, setAllPayment] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [reload, setReload] = useState(false);
  const [pagination, setPagination] = useState({
    current_page: 1,
    per_page: 10,
  });
  const debouncedText = useDebounce(searchText, 1000);

  const { data, loading, fetchData: fetchListData } = useApiCall();
  useEffect(() => {
    let finalPagination = { ...pagination };
    fetchListData(
      viewAllPayment,
      {
        body_data: { project_id, customer_id, invoice_id },
        params: `page=${finalPagination?.current_page}&limit=${finalPagination?.per_page}&search=${debouncedText}`,
      },
      false,
    );
  }, [reload, pagination?.current_page, pagination?.per_page, debouncedText]);

  useEffect(() => {
    if (data) {
      const { data: allData, ...rest } = data;
      setAllPayment(allData);
      setPagination(rest);
    }
  }, [data]);

  const permissions = usePermissions("payment");

  return addPayment ? (
    <MakePayment
      {...base}
      currPayment={currPayment}
      setAddPayment={setAddPayment}
      setReload={setReload}
      invoice_id={invoice_id}
    />
  ) : (
    <Box sx={{ m: "-20px" }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          p: "10px",
        }}
      >
        <SearchBox
          handleSearch={(text) => setSearchText(text)}
          placeholder={"Search in Payment.."}
        />
        {!!isCreate && permissions["create"] && (
          <Button
            startIcon={<BiPlus />}
            variant="outlined"
            onClick={() => {
              setCurrPayment({});
              setAddPayment(true);
            }}
          >
            New Payment
          </Button>
        )}
      </Box>
      <PaymentTable
        loading={loading}
        allPayment={allPayment}
        setReload={setReload}
        setAllPayment={setAllPayment}
        reload={reload}
        pagination={pagination}
        setPagination={setPagination}
        setAddPayment={setAddPayment}
        setCurrPayment={setCurrPayment}
        isEdit={isEdit}
        isDelete={isDelete}
        permissions={permissions}
      />
    </Box>
  );
};

export default Payment;
